import { render } from "./bannerBottom.vue?vue&type=template&id=172d9ada&scoped=true"
import script from "./bannerBottom.vue?vue&type=script&lang=js"
export * from "./bannerBottom.vue?vue&type=script&lang=js"

import "./bannerBottom.vue?vue&type=style&index=0&id=172d9ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172d9ada"]])

export default __exports__